import { useCallback, useRef } from 'react'
import QuizQuestionsSelector from '@v4/utils/selectors/QuizQuestionsSelector'
import QuestionsBuilderModel from '@v4/store/builderStore/models/QuestionsBuilder.model'
import QuestionsBuilderSelector from '@v4/utils/selectors/QuestionsBuilderSelector'
import AppStore from '@v4/store/appStore'
import PageBuilderSelector from '@v4/utils/selectors/PageBuilderSelector'
import PageBuilderModel from '@v4/store/builderStore/models/PageBuilder.model'
import useStyles from './OptionItem.styled'

export const useOptionItem = props => {
	const {
		className,
		pending,
		id,
		label,
		onClick,
		onKeyUp,
		checked,
		shadow,
		useOldCheckboxes,
		editable,
		onLabelEdit,
		draggable,
		type,
		deletable,
		onDelete,
		tabIndex,
		autoFocus,
		placeholder,
	} = props
	const classes = useStyles(props)
	const isBuilderMode = AppStore.useStoreState(state => state.general.isBuilderMode)
	const isQuestionBuilderMode = PageBuilderSelector.useIsQuestionsMode()
	const deletingOptionIds = QuizQuestionsSelector.useDeletingOptionIds()
	const { setSidebarMode } = PageBuilderSelector.useActions()
	const { setScrollingMenu, setActiveOptionId, setQuestionTab } = QuestionsBuilderSelector.useActions()
	const labelRef = useRef('')
	labelRef.current = label

	const handleLabelEdit = useCallback(
		option => {
			onLabelEdit({ id, option })
		},
		[id, onLabelEdit],
	)

	const handleDelete = useCallback(() => {
		onDelete(id)
	}, [id, onDelete])

	const handleLabelFocus = useCallback(() => {
		const pattern = /^Answer \d+$/g

		if (pattern.test(labelRef.current)) {
			handleLabelEdit('')
		}
		setScrollingMenu?.(true)
		setActiveOptionId(id)
		setSidebarMode(PageBuilderModel.SIDEBAR_MODE.QUESTIONS)
		setQuestionTab(QuestionsBuilderModel.QUESTION_TAB.LOGIC)
	}, [handleLabelEdit, id, setActiveOptionId, setQuestionTab, setScrollingMenu, setSidebarMode])

	return [
		{
			className,
			disabled: pending,
			value: id,
			label,
			checked,
			shadow,
			useOldCheckboxes,
			editable,
			classes,
			draggable,
			deletable,
			type,
			deleting: _.includes(deletingOptionIds, id),
			tabIndex,
			autoFocus,
			placeholder,
		},
		{
			handleClick: onClick,
			handleKeyUp: onKeyUp,
			handleLabelEdit,
			handleDelete,
			handleLabelFocus: isBuilderMode && isQuestionBuilderMode ? handleLabelFocus : undefined,
		},
	]
}
